export default "__VITE_ASSET__Dg4s1m8c__"